"use strict";

exports.__esModule = true;
exports.columnSorter = columnSorter;
exports.stringSort = exports.sortByState = exports.sortByFormatter = exports.sortByDeviceName = exports.sortByActivity = exports.numberSorter = exports.getColumnSorter = void 0;
var stringSort = exports.stringSort = function stringSort() {
  return function (a, b) {
    return (a || "").localeCompare(b || "");
  };
};
var sortByFormatter = exports.sortByFormatter = function sortByFormatter(formatter) {
  return function (a, b) {
    a = formatter({
      value: a
    }).toLowerCase();
    b = formatter({
      value: b
    }).toLowerCase();
    return a.localeCompare(b);
  };
};
var sortByDeviceName = exports.sortByDeviceName = function sortByDeviceName(devicesMap) {
  return function (a, b) {
    a = (devicesMap[a] || "").toLowerCase();
    b = (devicesMap[b] || "").toLowerCase();
    return a.localeCompare(b);
  };
};
var sortByState = exports.sortByState = function sortByState(statesMap) {
  return function (a, b) {
    a = (statesMap[a] || "").toLowerCase();
    b = (statesMap[b] || "").toLowerCase();
    return a.localeCompare(b);
  };
};
var sortByActivity = exports.sortByActivity = function sortByActivity(activitiesMap) {
  return function (a, b) {
    a = (activitiesMap[a] || "").toLowerCase();
    b = (activitiesMap[b] || "").toLowerCase();
    return a.localeCompare(b);
  };
};
var numberSorter = exports.numberSorter = function numberSorter(a, b) {
  // Invalid values should be grouped together at top of the list - appear first in ascending order

  // While comparing 2 numbers a and b, we want invalid values to be treated as lowest values
  // Hence invalid values should be treated as though they are of value NEGATIVE_INFINITY
  // But, the comparator returns a - b
  // Hence, if a is invalid, we will return NEGATIVE_INFINITY - b = NEGATIVE_INFINITY
  // If b is invalid, we will return a - NEGATIVE_INFINITY = POSITIVE_INFINITY
  var invalidValues = [null];
  if (invalidValues.includes(a)) {
    return Number.NEGATIVE_INFINITY;
  }
  if (invalidValues.includes(b)) {
    return Number.POSITIVE_INFINITY;
  }
  return a - b;
};
function columnSorter(_ref) {
  var devicesMap = _ref.devicesMap,
    statesMap = _ref.statesMap,
    activitiesMap = _ref.activitiesMap,
    formatter = _ref.formatter;
  return {
    device: sortByDeviceName(devicesMap),
    deviceName: sortByDeviceName(devicesMap),
    state: sortByState(statesMap),
    activity: sortByActivity(activitiesMap),
    string: stringSort(),
    date: function date(a, b) {
      return new Date(a).getTime() - new Date(b).getTime();
    },
    duration: numberSorter,
    age: numberSorter,
    creator: sortByFormatter(formatter),
    assignee: sortByFormatter(formatter),
    status: stringSort()
  };
}
var getColumnSorter = exports.getColumnSorter = function getColumnSorter(_ref2) {
  var devicesMap = _ref2.devicesMap,
    statesMap = _ref2.statesMap,
    activitiesMap = _ref2.activitiesMap,
    formatter = _ref2.formatter,
    type = _ref2.type;
  if (type === "lookUpForTypeInRow") {
    return numberSorter;
  }
  switch (type) {
    case "device":
      return sortByDeviceName(devicesMap);
    case "deviceName":
      return sortByDeviceName(devicesMap);
    case "state":
      return sortByState(statesMap);
    case "activity":
      return sortByActivity(activitiesMap);
    case "string":
      return stringSort();
    case "number":
      return numberSorter;
    case "date":
      return function (a, b) {
        return new Date(a).getTime() - new Date(b).getTime();
      };
    case "duration":
      return numberSorter;
    case "age":
      return numberSorter;
    case "creator":
      return sortByFormatter(formatter);
    case "assignee":
      return sortByFormatter(formatter);
    case "status":
      return stringSort();
    case "total":
      return numberSorter;
    case "average":
      return numberSorter;
    case "hour":
      return numberSorter;
    case "fractionalPercent":
      return numberSorter;
    default:
      return stringSort();
  }
};